import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#fire-calculator-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'USD';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let swr = parseFloat($container.data('swr')) || 4.0;
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#fire-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const culture = $container.data('culture') || 'uk-UA';
    const localeMap = { 'uk': 'uk-UA', 'pl': 'pl-PL', 'de': 'de-DE', 'es': 'es-ES', 'it': 'it-IT', 'en': 'en-US' };
    const dateLocale = localeMap[culture] || 'en-US';

    const unitPerMonth = $container.data('unit-per-month') || '/ міс';
    const unitYears = $container.data('unit-years') || 'р.';
    const seriesCapital = $container.data('series-capital') || 'Ваш капітал';
    const seriesTarget = $container.data('series-target') || 'Цільовий капітал FIRE';
    const textAchieved = $container.data('text-achieved') || 'Досягнуто! 🎉';

    const $expenseRange = $('#fire-expense-range');
    const $expenseDisplay = $('#fire-expense-display');

    const $networthRange = $('#fire-networth-range');
    const $networthDisplay = $('#fire-networth-display');

    const $savingsRange = $('#fire-savings-range');
    const $savingsDisplay = $('#fire-savings-display');

    const $returnRange = $('#fire-return-range');
    const $returnDisplay = $('#fire-return-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString(dateLocale) + ' ' + symbol;
    }

    function calculate() {
        const monthlyExpense = parseFloat($expenseRange.val()) || 1500;
        const currentNetWorth = parseFloat($networthRange.val()) || 0;
        const monthlySavings = parseFloat($savingsRange.val()) || 800;
        const annualReturn = (parseFloat($returnRange.val()) || 8.0) / 100;

        $expenseDisplay.text(formatMoney(monthlyExpense) + ' ' + unitPerMonth);
        $networthDisplay.text(formatMoney(currentNetWorth));
        $savingsDisplay.text(formatMoney(monthlySavings) + ' ' + unitPerMonth);
        $returnDisplay.text((annualReturn * 100).toFixed(1) + '%');
        $('#fire-swr-display').text(swr.toFixed(1) + '%');

        // Target Nest Egg = Annual Expenses / SWR
        const annualExpense = monthlyExpense * 12;
        const targetNestEgg = Math.round(annualExpense / (swr / 100));

        // Progress percentage
        const progressPct = targetNestEgg > 0 ? Math.min(100, Math.max(0, (currentNetWorth / targetNestEgg) * 100)) : 100;

        $('#fire-kpi-target').text(formatMoney(targetNestEgg));
        $('#fire-kpi-progress').text(progressPct.toFixed(1) + '%');
        $('#fire-progress-bar').css('width', progressPct + '%').text(progressPct.toFixed(1) + '%');
        $('#fire-progress-current-text').text(formatMoney(currentNetWorth));
        $('#fire-progress-target-text').text(formatMoney(targetNestEgg));

        // Variations
        $('#fire-lean-val').text(formatMoney(targetNestEgg * 0.75));
        $('#fire-regular-val').text(formatMoney(targetNestEgg));
        $('#fire-fat-val').text(formatMoney(targetNestEgg * 1.5));
        $('#fire-barista-val').text(formatMoney(targetNestEgg * 0.5));

        // Simulate Years to FIRE
        let balance = currentNetWorth;
        let months = 0;
        const maxMonths = 50 * 12;
        const monthlyRate = annualReturn / 12;

        const timelineLabels = ['0 ' + unitYears];
        const balanceData = [Math.round(balance)];
        const targetLineData = [targetNestEgg];

        while (balance < targetNestEgg && months < maxMonths) {
            months++;
            balance = (balance + monthlySavings) * (1 + monthlyRate);

            if (months % 12 === 0 || balance >= targetNestEgg) {
                const yearNum = (months / 12).toFixed(1) + ' ' + unitYears;
                timelineLabels.push(yearNum);
                balanceData.push(Math.round(balance));
                targetLineData.push(targetNestEgg);
            }
        }

        const yearsToFire = (months / 12).toFixed(1);
        $('#fire-kpi-years').text(yearsToFire <= 0 ? textAchieved : yearsToFire + ' ' + unitYears);

        renderChart(timelineLabels, balanceData, targetLineData);
    }

    function renderChart(labels, balanceData, targetData) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: [
                { name: seriesCapital, data: balanceData },
                { name: seriesTarget, data: targetData }
            ],
            chart: {
                type: 'line',
                height: 250,
                toolbar: { show: false },
                animations: { enabled: true, speed: 400 }
            },
            colors: ['#556ee6', '#f1b44c'],
            stroke: {
                curve: 'smooth',
                width: [3, 2],
                dashArray: [0, 5]
            },
            dataLabels: { enabled: false },
            xaxis: {
                categories: labels,
                labels: { style: { colors: isDark ? '#a6b0cf' : '#74788d' } }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M ' + symbol;
                        if (val >= 1000) return Math.round(val / 1000) + 'K ' + symbol;
                        return Math.round(val) + ' ' + symbol;
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            tooltip: {
                theme: isDark ? 'dark' : 'light',
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        const chartEl = document.querySelector('#fire-timeline-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Event Listeners
    $expenseRange.on('input', calculate);
    $networthRange.on('input', calculate);
    $savingsRange.on('input', calculate);
    $returnRange.on('input', calculate);

    // SWR Buttons
    $('.swr-btn').on('click', function () {
        $('.swr-btn').removeClass('active');
        $(this).addClass('active');
        swr = parseFloat($(this).data('swr')) || 4.0;
        calculate();
    });

    // Currency Switcher
    function setFireCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#fire-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.fire-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.fire-more-currencies-btn').addClass('active');
            $('#fire-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#fire-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.fire-more-currencies-btn').removeClass('active');
            $('.fire-currency-dropdown-item').removeClass('active');
            $('#fire-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const defExpense = parseFloat($(btn).data('default-expense')) || 1500;
        const defSavings = parseFloat($(btn).data('default-savings')) || 800;
        const defNetWorth = parseFloat($(btn).data('default-networth')) || 20000;
        const defReturn = parseFloat($(btn).data('default-return')) || 8.0;

        $expenseRange.val(defExpense);
        $savingsRange.val(defSavings);
        $networthRange.val(defNetWorth);
        $returnRange.val(defReturn);

        if (currency === 'UAH' || currency === 'CZK') {
            $expenseRange.attr({ max: 200000, step: 2000 });
            $savingsRange.attr({ max: 100000, step: 1000 });
            $networthRange.attr({ max: 5000000, step: 50000 });
        } else if (currency === 'PLN') {
            $expenseRange.attr({ max: 50000, step: 500 });
            $savingsRange.attr({ max: 30000, step: 200 });
            $networthRange.attr({ max: 1500000, step: 10000 });
        } else {
            $expenseRange.attr({ max: 15000, step: 100 });
            $savingsRange.attr({ max: 10000, step: 50 });
            $networthRange.attr({ max: 500000, step: 5000 });
        }

        calculate();
    }

    $('#fire-currency-tabs > button[data-currency-code]').on('click', function () {
        setFireCurrency(this, false);
    });

    $(document).on('click', '.fire-currency-dropdown-item', function (e) {
        e.preventDefault();
        setFireCurrency(this, true);
    });

    calculate();
});

